module.exports = __webpack_public_path__ + "static/media/error.acd489e0.mp3";